// 用户中心-优惠券操作
const UserCouponRouterMap = [
  // 用户优惠券列表
  {
    path: '/user/coupon',
    component: Coupon => (require(['@/views/user/coupon'], Coupon))
  },
  // 领取优惠券
  {
    path: '/user/collect-coupon',
    meta: {index: 1, title: '稻草人旅行优惠券'},
    component: CollectCoupon => (require(['@/views/user/collectCoupon'], CollectCoupon))
  },
  // 优惠券去使用列表
  {
    path: '/user/applicable-sku',
    component: ApplicableSku => (require(['@/views/user/applicableSku'], ApplicableSku))
  },
  // 权益卡（双十二）
  {
    path: '/user/benefit-card',
    component: BenefitCard => (require(['@/views/user/benefitCard'], BenefitCard))
  }
]

export default UserCouponRouterMap



// WEBPACK FOOTER //
// ./src/router/modules/user/coupon.js